import { FINAL_REPORT, PROGRESS_REPORT } from 'utility/postApprovalLookUp';
import API from './index';

const api = {
    createReport(data) {
        return API.authAPI({
            url: '/approval/create-report',
            method: 'POST',
            data,
        });
    },
    getReportDetail(data) {
        return API.authAPI({
            url: '/approval/get-report-detail',
            method: 'GET',
            params: { ...data },
        });
    },
    updateStatusCommon({ docType, docId, updateStatus, comment, uploadTempId }) {
        return API.authAPI({
            url: '/approval/update-status-common',
            method: 'POST',
            data: { docType, docId, updateStatus, comment, uploadTempId },
        });
    },
    returnDocument({ docType, docId, updateStatus, comment, uploadTempId, expiryDate }) {
        return API.authAPI({
            url: '/approval/return',
            method: 'POST',
            data: { docType, docId, updateStatus, comment, uploadTempId, expiryDate },
        });
    },
    distributeDocument({ docType, docId, updateStatus, comment, uploadTempId, cluster }) {
        return API.authAPI({
            url: '/approval/distribute',
            method: 'POST',
            data: { docType, docId, updateStatus, comment, uploadTempId, distributedCluster: cluster },
        });
    },
    rejectRequestForRequest({ docType, docId, comment, uploadTempId }) {
        return API.authAPI({
            url: '/approval/reject-request-for-request',
            method: 'POST',
            data: { docType, docId, comment, uploadTempId },
        });
    },
    getComment(data) {
        return API.authAPI({
            url: `/approval/get-comment/${data.docType}/${data.docId}`,
            method: 'GET',
            params: {},
        });
    },
    downloadStatusFile(data) {
        return API.authAPI({
            url: `/approval/download-status-file/${data.id}`,
            method: 'GET',
            params: {},
            responseType: 'blob',
        });
    },
    checkExistProgressReport(appId, siteId) {
        return API.authAPI({
            url: `/approval/check-exists-report/${PROGRESS_REPORT}`,
            method: 'GET',
            params: { siteId, appId },
        });
    },
    checkExistFinalReport(appId) {
        return API.authAPI({
            url: `/approval/check-exists-report/${FINAL_REPORT}`,
            method: 'GET',
            params: { appId },
        });
    },
    generateReport(data) {
        return API.authAPI({
            url: `/generate/generate-report/${data.docType}/${data.docId}`,
            method: 'GET',
            params: {},
            responseType: 'blob',
        });
    },
    downloadDocument(data) {
        return API.authAPI({
            url: `/approval/download-supplementary/${data.id}`,
            method: 'GET',
            responseType: 'blob',
            timeout: 1000 * 60 * 10,
        });
    },
};

export default api;
